
    jQuery(document).ready(
      function(){
        //move the tabs
        //
        if(jQuery('body').attr('id') != 'gw200' && jQuery('body').attr('id') != 'signature-s150' && jQuery('body').attr('id') != 'red4' && jQuery('body').attr('id') != 'green4' && jQuery('body').attr('id') != 'gold4' && jQuery('body').attr('id') != 'opus4' && jQuery('body').attr('id') != 'platinum4' && jQuery('body').attr('id') != 'sonata4' && jQuery('body').attr('id') != 'master4' && jQuery('body').attr('id') != 'reference4' && jQuery('body').attr('id') != 'statement4' && jQuery('body').attr('id') != 'aeon4' && jQuery('body').attr('id') != 'epoch4' && jQuery('body').attr('id') != 'gs3000' && jQuery('body').attr('id') != 'gs1000' && jQuery('body').attr('id') != 'grado-rs1-headphones' && jQuery('body').attr('id') != 'grado-sr80-headphones' && jQuery('body').attr('id') != 'grado-sr60-headphones' && jQuery('body').attr('id') != 'hemp-classic' && jQuery('body').attr('id') != 'grado-sr325-headphones' && jQuery('body').attr('id') != 'signature-s550' && jQuery('body').attr('id') != 'signature-s750' && jQuery('body').attr('id') != 'gold-detachable-cables'){
        jQuery('.product__info-wrapper.grid__item:nth-child(2)').append(jQuery('.product__info-as-bottom-tabs'));
      }
       // var theFilter = jQuery('body#prestige-series aside facet-filters-form').clone();
         jQuery('body#prestige-series .page-full-width aside facet-filters-form').remove();
       //  jQuery('#ProductGridContainer .page-full-width facet-filter-form .filter-style').after(theFilter);
       // var theReviews = jQuery('.main-product_info.product .rating').clone();
       // jQuery('.main-product_info.product .rating').remove();
        //jQuery('.main-product_info.product .price-tag').after(theReviews);
        
       
        jQuery('.product-form__input input').on('change', function(){
         
       

          
        });
       setInterval(
          function(){
             var theNewPrice = jQuery('.orig-price .price').attr('data-price');
             jQuery('.clone-price .price-item').text(theNewPrice);
             //console.log(theNewPrice);
          }, 500
        ); 

        if(jQuery('body').hasClass('index')){
          jQuery('.home-three-column-grid-section-gold-background .multicolumn-card.content-container').each(function(){
            jQuery(this).on('click', function(){
              window.location = jQuery(this).find('a').attr('href');
            })
          });
        }
function addTheButtons(){
  //console.log('not loading');
  if(jQuery('.product-recommendations .card__content .price').length > 0){
         jQuery('.product-recommendations .card__content').each(
            function(){
               // console.log('a card button');
                var theLink = jQuery(this).find('a').attr('href');
                var theLinkButton = '<a class="recommended-prod-button button" href="'+theLink+'">SELECT OPTIONS</a>';
                jQuery(this).find('.card__heading').parent().append(theLinkButton);
              // console.log('adding buttons');
            });
            }
           else{
             setTimeout(function(){
               addTheButtons();
             },200);
           }
       
}
  if(jQuery('body').hasClass('product')){
    addTheButtons();  
  }
      }
    );  
//add tooltips to the options and accessories note
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function(event){
     /* jQuery('.bold_option_value_price').each(
        function(){
            var theprice = jQuery(this).text();
            jQuery(this).text('[+'+theprice+']');
        }
      );*/
    //need to move the options to the right place and add a custom div
  // var theNewBoldOptions = jQuery('div.bold_options.bold_options_loaded').first().appendTo('#keep-bold-options');
    //jQuery('div.bold_options.bold_options_loaded').remove();
   //jQuery('#keep-bold-options').html(theNewBoldOptions);
  //actually move other stuff because bold isn't working
    //jQuery('.main-product_info .product-form__buttons').before(jQuery('.price-tag clone-price'));
    
    jQuery('.main-product_info .product-form__buttons').before(jQuery('.main-product_info .product-form__input.product-form__quantity'));
    
    
    
     var thePriceTag = jQuery('.main-product_info.product .price-tag').clone();
        jQuery('.main-product_info.product .price-tag').addClass('orig-price');
        jQuery('.main-product_info.product .product-form__input.product-form__quantity').after(thePriceTag);
        jQuery('.main-product_info.product .price-tag').last().addClass('clone-price');
    jQuery('.main-product_info .product-form__buttons').before(jQuery('.product-attributes'));
    jQuery('#keep-bold-options div.bold_options.bold_options_loaded').before('<h4 style="width:100%;clear:both;font-size:14px;">Save on accessories with purchase of a headphone</h4>');
      jQuery('.main-product_info .product-form__buttons').before(jQuery('#product-inventory'));  

   

    if(jQuery('#product-manual').length > 0){
         console.log('move the manual');
         jQuery('.main-product_info .product-form__buttons').before(jQuery('#product-manual'));
       
      }
      
       if(jQuery('#web-manual').length > 0){
         console.log('move the manual');
         jQuery('.main-product_info .product-form__buttons').before(jQuery('#web-manual'));
       
      }


      if(jQuery('#product-notes').length > 0){
         console.log('move the notes');
         jQuery('.main-product_info .product-form__buttons').before(jQuery('#product-notes'));
       
      }
    jQuery('.bold_option_value_title').each(
        function(){
            var thetext = jQuery(this).text();
          switch(thetext){
            case 'Small wood box [Save $10]':
            var thetooltip = 'Small wood case fits: All Prestige Series, RS2, PS500, GH1/2/3/4, Hemp, GW100';
            break;
            case 'Large wood box with small foam insert [Save $20]':
            var thetooltip = 'Small foam insert fits: All Prestige Series, RS1, RS2, PS500, GH1/2/3/4, Hemp, GW100';
            break;
            case 'Large wood box with large foam insert [Save $20]':
            var thetooltip = 'Large foam insert fits: GS1000/2000/3000, PS1000/2000, White Headphone';
            break;
            case 'Medium hardshell case  [Save $5]':
            var thetooltip = 'Fits: SR60e, SR80e, SR125e, SR225e, SR325e, GW100, RS2, PS500, GH1/2/3/4';
            break;
            case 'Large hardshell case  [Save $5]':
            var thetooltip = 'Fits: PS1000e, PS2000e, GS1000e, GS2000e, GS3000e, RS1, WH1';
            break;
            default:
            var thetooltip = '';
            console.log('do nothing '+ thetext);
          }
          
          if(thetext.indexOf('[') > -1){
          var thesplittext = thetext.split('[');
          var thenewtext = thesplittext[0] + '<strong>['+thesplittext[1] + '</strong>';
          jQuery(this).html(thenewtext);
          }
          
          
          if(thetooltip != ''){
             jQuery(this).parent().append('<span class="options-tooltip-4oe-wrap"><span class="options-tooltip-4oe">?</span></span><div class="options-tooltip-4oe-info" style="display:none;"><p>'+thetooltip+'</p></div>');
          }
          jQuery('.options-tooltip-4oe-wrap').each(
            function(){
              jQuery(this).on('mouseenter touchstart',function(){
                  jQuery(this).next().show();
              });
              jQuery(this).on('mouseleave touchend',function(){
                  jQuery(this).next().hide();
              });
            }
          );
        }
      );
//change the first options to say select a.
  if(jQuery('body').hasClass('product')){
    jQuery('variant-selects option, .bold_option_element option').each(
      function(){
        console.log(jQuery(this).text());
        if(jQuery(this).text().indexOf('Save on a') >= 0){
          var theNewText = jQuery(this).text().replace('Save on a','Select a');
          jQuery(this).text(theNewText);
        }
      }
    );
  }
    

    
  });

//toggles functionality for product options/addons
jQuery(document).ready(function(){
   //add in the options toggle functionality
    jQuery('.product__info-wrapper variant-selects').before('<div id="custom-options-toggle"><div class="h4" style="font-size:24px;">Options: <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div></div>');
  if(jQuery('#custom-options-toggle').length){
      jQuery('#custom-options-toggle').on(
        'click', function(){
          jQuery('#main-product-form-wrapper .bold_options').toggleClass('options-visible');
          jQuery('.product__info-wrapper variant-selects').toggleClass('options-visible');
          jQuery('#custom-options-toggle').toggleClass('options-visible');
        }
      );
    
    }

    
});
//fix sticky bar
//jQuery(document).ready(function(){

    //fix stickybar
  //if(jQuery('body').attr('id') == 'grado-rs2x-headphones'){
    //console.log('is rs2x append sticky');
   // jQuery('body').append(jQuery('#sticky-bar-form'));
  //}
    
//});
//fix accessibility issue on banner images - by adding name attribute 
 jQuery(document).ready(
  function(){
    jQuery('a.grid-banner-image').each(
      function(){
        console.log(jQuery(this).attr('name'));
         if(typeof jQuery(this).attr('name') === "undefined"){
           console.log('fixing a link');
           jQuery(this).attr('name','This Links to '+jQuery(this).attr('href'));
         }
      }
    );
  }
);
//fix homepage h orders by wrapping headphone sub items in h3
jQuery(document).ready(
  function(){
    jQuery('#Slider-template--15098044055600__7fa66b28-56c0-4efd-a997-75d656707c8d a.button').each(
        function(){
         jQuery(this).wrap('<h3></h3>');
        }
    );
  }
);

//fix shogun category product grids not having alt on images
/*
jQuery(document).ready(
  function(){
    jQuery('.shg-category-grid .shg-product').each(
      function(){
        var theGridItemTitle = jQuery(this).find('.shg-product-title-component h3 span').text();
        console.log(jQuery(this).find('.shg-product-title-component h3 span'));
        console.log(theGridItemTitle);
        
        var theGridItemImageLink = jQuery(this).find('.shogun-product-image-url');
        var theGridItemImageImage = jQuery(this).find('.shogun-product-image-url img');
        jQuery(theGridItemImageLink).attr('aria-label','Link to view the '+theGridItemTitle+' Page');
        jQuery(theGridItemImageImage).attr('alt','Side view photo of the '+theGridItemTitle+'. Click the image to view the '+theGridItemTitle+' Page');
      }
    );
  }
);*/
//make header nav keyboard accessible
jQuery(document).ready(
  function(){
    jQuery(document).on('keyup', function(e) {
    if (e.keyCode === 27) {
        // Your action here
        console.log('escape');
        jQuery('nav#AccessibleNav .sub-menu-block').each(
          function(){
            jQuery(this).addClass('is-hidden');
          }
        );

        jQuery('.main-menu-dropdown-sub-trigger').each(
          function(){
            jQuery(this).attr('aria-expanded','false');
          }
        );
      }
     });
       jQuery('.main-menu-dropdown-sub-trigger').each(
        function(){
           jQuery(this).on('click',
            function(event){
              event.stopImmediatePropagation();
              event.preventDefault();
              console.log('enter was pressed');
              jQuery(this).parent().next().removeClass('is-hidden');
              jQuery(this).attr('aria-expanded','true');
            }
           );
        }
       );
  }
);

//add explicit label/input connection for reviews widget
jQuery(document).ready(
  function(){
    //check that reviews are present
    console.log('about to load reviews changes');
    if(jQuery('body').hasClass('product')){
    function makeTheReviewACChanges(){
       if(jQuery('.jdgm-sort-dropdown-wrapper').length > 0){
      console.log('running dropdown changes');
         jQuery('.jdgm-sort-dropdown-wrapper .jdgm-sort-dropdown-label').addClass('gl-as-hide');
        jQuery('.jdgm-sort-dropdown-wrapper .jdgm-sort-dropdown').attr('id','gl-review-sortby');
         jQuery('.jdgm-sort-dropdown-wrapper').attr('for','gl-review-sortby');
         }
    else{
      setTimeout(function(){
        makeTheReviewACChanges();
      },200);
    }
    }
    makeTheReviewACChanges();
    
  }
  }
);